import React from 'react';
import PedidoEdit from './PedidoEditNew';

const PedidoCreate = () => {
  return <PedidoEdit />;
};

export default PedidoCreate;
